export const L10N = {
  LABEL_GREETINGS: { id: 'lisa.label.greetings' },
  LABEL_HI: { id: 'lisa.label.hi' },
};
